<template>
  <div class="adminLogin">
    <div class="adminLogin__container">
      <div class="adminLogin__header">
        <h1>後台</h1>
      </div>
      <div class="adminLogin__body">
        <form @submit.prevent='login'>
          <div class="loginForm">
            <div class="loginForm__container">
              <div class="loginForm__header">
                <p>管理者登入</p>
              </div>
              <div class="loginForm__body">
                <div class="inputGroup">
                  <label class="inputGroup__inputText">
                    <span class="inputGroup__title">帳號</span>
                    <input type="text" required v-model="form.account">
                  </label>
                </div>
                <div class="inputGroup">
                  <label class="inputGroup__inputPassword">
                    <span class="inputGroup__title">密碼</span>
                    <input type="password" required v-model="form.password">
                  </label>
                </div>
                <div class="inputGroup inputGroup--center">
                  <button type="submit" class="inputGroup__submit">
                    登入
                  </button>
                  <a href="#" class="myBtn myBtn--secondary"
                  @click="go_page('/')">回到首頁</a>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    admins() {
      let arr = [];
      this.$bus.$on('son_get_data', (data) => {
        arr = data.administrators;
      });
      this.$bus.$emit('son_call_data');
      return arr;
    },
    admin() {
      let obj;
      this.$bus.$on('son_get_data', (data) => {
        obj = data.administrator;
      });
      this.$bus.$emit('son_call_data');
      return obj;
    },
  },
  data() {
    return {
      form: {
        account: '',
        password: '',
      },
    };
  },
  methods: {
    go_page(route) {
      this.$router.push(route);
    },
    login() {
      const thisAcc = this.form.account;
      const thisPwd = this.form.password;
      const targetAcc = this.admins.find((item) => item.account === thisAcc);
      const verifyAcc = () => {
        let pass = false;
        if (targetAcc === undefined) {
          alert('無此帳號');
        } else {
          pass = true;
        }
        return pass;
      };
      const verifyPwd = () => {
        let pass = false;
        if (verifyAcc() && targetAcc.password !== thisPwd) {
          alert('密碼錯誤');
        } else {
          pass = true;
        }
        return pass;
      };

      if (verifyAcc() && verifyPwd()) {
        alert('登入成功');
        this.$bus.$emit('admin_login', targetAcc);
        this.go_page('/back');
      }
    },
  },
  created() {
    if (this.admin.id !== '') {
      this.go_page('/back');
    }
  },
};
</script>
